import React from "react";
const Header = () => {
  return (
    <header id="header" className="fixed-top d-flex align-items-center">
    <div className="container d-flex align-items-center">
      <h1 className="logo me-auto"><a href="#">Progress <span>Solution</span></a></h1>

      <nav id="navbar" className="navbar order-last order-lg-0">
        <ul>
          <li><a className="nav-link scrollto active" href="#hero">Home</a></li>
          <li><a className="nav-link scrollto" href="#about">About</a></li>
          <li><a className="nav-link scrollto" href="#services">Services</a></li>
          {/* <li><a className="nav-link scrollto " href="#photo">Photos</a></li> */}
        
          <li><a className="nav-link scrollto" href="#contact">Contact</a></li>
        </ul>
        <i className="bi bi-list mobile-nav-toggle"></i>
      </nav>

      {/* <a href="#contact" className="get-started-btn scrollto">Raise Service Request</a> */}
    </div>
  </header>
  );
};

export default Header;
